import { AgentType } from '@/api/types/agent.type'

/**
 * 智能体分类选项
 */
export const AGENT_CATEGORY_OPTIONS = [
  { value: AgentType.WRITING, label: '写作类' },
  { value: AgentType.CREATIVE_MASTER, label: '创作大师' },
  { value: AgentType.EFFICIENCY_TOOL, label: '效率神器' },
  { value: AgentType.CREATIVE_FULL, label: '创意满分' },
] as const

/**
 * 智能体分类选项（包含全部分类）
 */
export const AGENT_CATEGORY_OPTIONS_WITH_ALL = [
  { value: 'all', label: '全部分类' },
  ...AGENT_CATEGORY_OPTIONS,
] as const
